import { getController } from '@/services/service'

const url = 'propertymanagers'

export const propertyManagerService = {
	...getController<Api.PropertyManager, Api.PropertyManagerPostInput>(url),
}

export default propertyManagerService
